import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import ArticleCard from './ArticleCard';

const Wrapper = styled.div`
  --cols: 2;
  padding: 4rem 0 2rem;
  margin-top: 4rem;
  border-top: solid 1px #ccc;

  ${p =>
    p.layout === 'sidebar' &&
    css`
      --cols: 1;
      background: var(--nude-100);
      border: none;
      margin: 2rem auto;
      padding: 30px;

      @media (min-width: 768px) {
        max-width: 400px;
        margin: 4rem;
        float: right;
      }

      @media (min-width: 1399px) {
        margin-right: -220px;
      }
    `}
`;

const Title = styled.h2`
  margin: 0 0 1rem;
`;

const Subtitle = styled.h4`
  margin: 1rem 0 3rem;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(var(--cols), 1fr);
  gap: 55px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const getTitleAndSubtitle = count => {
  if (!count) return {};

  const messages = {
    1: {
      title: 'That’s 1 down, 2 to go!',
      subtitle:
        'When planning your wedding, knowledge is power. Read two more articles before you go – because the more you know, the more you know!',
    },
    2: {
      title: "That's 2 down, you're nearly there!",
      subtitle:
        'When planning your wedding, knowledge is power. Read just one more article before you go and nothing can stop you!',
    },
    3: {
      title: "You're unstoppable! You have learned 3 new things today!",
      subtitle:
        "Armed with these new tips and tricks, your wedding planning is sure to be a breeze. But don't stop now, keep learning.",
    },
  };

  return (
    messages[count] || {
      title: `You have read ${count} new things today, go you!`,
      subtitle:
        "Armed with these new tips and tricks, your wedding planning is sure to be a breeze. But don't stop now, keep learning.",
    }
  );
};

const getArticlesRead = () => {
  const storedValue = sessionStorage.getItem('ARTICLES_READ_IN_SESSION');
  try {
    return storedValue ? JSON.parse(storedValue) : [];
  } catch (error) {
    console.error('Failed to parse articles read from session storage:', error);
    return [];
  }
};

const updateArticlesRead = articleId => {
  const articlesReadArray = getArticlesRead();

  if (!!articleId && !articlesReadArray.includes(articleId)) {
    articlesReadArray.push(articleId);
    sessionStorage.setItem(
      'ARTICLES_READ_IN_SESSION',
      JSON.stringify(articlesReadArray)
    );
  }

  return articlesReadArray;
};

const RelatedArticles = ({ articles, limit = 6, articleId, type = 'readnext' }) => {
  const [readCount, setReadCount] = useState(0);

  useEffect(() => {
    const updatedArticlesRead = updateArticlesRead(articleId);
    setReadCount(updatedArticlesRead.length);
  }, [articleId]);

  if (!articles?.length) return null;

  const intro =
    type === 'readnext'
      ? getTitleAndSubtitle(readCount)
      : {
          title: 'Related articles',
          subtitle: 'Read more about wedding planning',
        };

  return (
    <Wrapper layout={type}>
      {intro.title && <Title>{intro.title}</Title>}
      {intro.subtitle && <Subtitle>{intro.subtitle}</Subtitle>}
      <Grid>
        {articles.slice(0, limit).map(article => (
          <ArticleCard
            key={article.id}
            article={article}
            elements={{ stand_first: type === 'readnext' }}
          />
        ))}
      </Grid>
    </Wrapper>
  );
};

export default RelatedArticles;
